module.exports = __webpack_public_path__ + "img/logo-teman-bakat.22d2b143.png";